module.exports = __webpack_public_path__ + "img/feature_buy_th.ae6fb4ac.png";